import { Swiper, Scrollbar, Navigation, Mousewheel } from 'swiper'
import { Fancybox } from '@fancyapps/ui'

import './video-slider.scss'

Fancybox.defaults.closeButton = 'outside'

const initVideoSlider = () => {
  new Swiper('.video-slider__slider.swiper', {
    modules: [Scrollbar, Navigation, Mousewheel],
    slidesPerView: 'auto',
    simulateTouch: true,
    spaceBetween: 16,

    scrollbar: {
      el: '.video-slider__slider-scrollbar.swiper-scrollbar',
      draggable: true,
    },

    navigation: {
      prevEl: '.video-slider__slider-navigation.prev',
      nextEl: '.video-slider__slider-navigation.next',
    },

    mousewheel: {
      forceToAxis: true,
    },

    breakpoints: {
      768: {
        slidesPerView: 4,
        spaceBetween: 40,
      },
    },
  })
}

document.addEventListener('DOMContentLoaded', async function () {
  initVideoSlider()
})
